import {
  boroughBoundaryLayer,
  boroughBufferBoundaryLayer,
  initialCenterWCC,
} from '@utils';
import * as ELG from 'esri-leaflet';
import { LatLngTuple } from 'leaflet';
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

interface EsriTileLayerProps {
  enableBuffer?: boolean;
}

export const EsriTileLayer = ({ enableBuffer }: EsriTileLayerProps) => {
  const map = useMap();
  map.attributionControl.setPrefix(false);
  const streetLayer = ELG.basemapLayer('Streets');
  useEffect(() => {
    map.addLayer(streetLayer);
    map.setView(initialCenterWCC as LatLngTuple);
    if (enableBuffer) {
      map.addLayer(boroughBufferBoundaryLayer);
    } else {
      map.addLayer(boroughBoundaryLayer);
    }
  }, [enableBuffer]);

  return null;
};
